import React, { useEffect, useState } from "react";
import { FiEdit } from "react-icons/fi";
import { Cookies } from "../../index.js";
import axios from "axios";
import { RingLoader, ClipLoader } from "react-spinners";
import { alert_error, alert_success } from '../../AppContext';
import Select from 'react-select';
function Getinfotask({ item, edit, options, setoptions }) {
    const [chietkhau, setchietkhau] = useState('');
    const [showRegistration, setShowRegistration] = useState(false);
    const [showtele, setshowtele] = useState(false);
    const handleRegistrationClick = () => {
        // Hiển thị mã đăng ký khi nút "Mã đăng ký" được nhấn
        setShowRegistration(true);
        // Thực hiện logic khác nếu cần
    };

    const handleEditClick = () => {
        // Gọi hàm onEditClick từ component cha khi nút chỉnh sửa được nhấp
        edit();
    };

    function embedtele() {
        if (item.guide) {
            // Trích xuất phần "freefltiktok" và "193" từ URL
            const [, guideName, guideId] = item.guide.match(/\/([^\/]+)\/(\d+)$/);
            if (guideName && guideId) {
                console.log("Guide Name:", guideName);
                console.log("Guide ID:", guideId);
                const script = document.createElement("script");
                script.src = "https://telegram.org/js/telegram-widget.js?22";
                script.async = false;
                script.setAttribute("data-telegram-post", guideName + "/" + guideId);
                script.setAttribute("data-width", "100%");

                const telegramDiv = document.getElementById("telegram");
                // Xử lý khi script được tải xong
                script.onload = () => {
                    console.log("Telegram script loaded successfully!");
                    setTimeout(() => {
                        setshowtele(true);
                    }, 500);
                    // Thêm các logic xử lý sau khi script đã được tải xong ở đây
                };
                // Thêm script vào thẻ div có id="telegram"
                telegramDiv.appendChild(script);

                // Xóa script khi component bị hủy
                return () => {
                    telegramDiv.removeChild(script);
                };
            }
        }
    };
    function saochep(value) {
        alert_success('Đã sao chép');
        window.saochepnative(value);
    };
    function nhadichvu(response) {
        setoptions(response.data);
        // setIsDisabled(false)
    };
    const [money, setmoney] = useState(null);
    function tinhgia2(amountok, rate) {
        if (chietkhau) {
            const giagiamok = rate * amountok * chietkhau / 100;
            const giaok = rate * amountok - giagiamok;
            setmoney(giaok);
        }
    }
    function laydulieu() {
        const apikey = Cookies.get("apikey");
        axios
            .post("https://hust.media/getservice/service.php", {
                category: "app_auto_jop",
            })
            .then((response) => nhadichvu(response))
            .catch((error) => alert_error(error));

        axios
            .post("https://hust.media/api/wallet/laychietkhau.php?apikey=" + apikey)
            .then((response) => setchietkhau(response.data))
            .catch((error) => console.log(error));
    }
    useEffect(() => {
        embedtele();
        if (item.category == 'app_auto_jop') {
            laydulieu();
        }
    }, []);

    const [service, setservice] = useState('');
    const [content, setcontent] = useState('');
    const [isOpen, setIsOpen] = useState(true);
    const [nutxuly, setnutxuly] = useState(0);
    const [nutorder, setnutorder] = useState('✔️ Click to Confirm');

    const handleFocus = () => {
        setIsOpen(true);
        console.log(123);
    };
    const handleBlur = () => {
        setIsOpen(false);
    };
    const handleMenuOpen = () => {
        setIsOpen(true);
    };
    const handleOptionChange = (selectedOption) => {
        setIsOpen(false);
        const selectedOptionpro = selectedOption.value;
        console.log(selectedOptionpro);
        setservice(selectedOptionpro);
        const selectedOptionok = options.find((option) => option.id == selectedOptionpro);
        tinhgia2(1, selectedOptionok.money);
        setcontent(selectedOptionok.money);
        // Thêm các hành động khác tại đây dựa trên lựa chọn của người dùng
    }
    function handleSubmit(event) {
        setnutxuly(0);
        const apikey = Cookies.get("apikey");
        const national_market = Cookies.get("national_market");
        event.preventDefault();

        setnutxuly(1);
        setnutorder("Please wait a moment 😊");
        if (!service) {
            alert("Please điền đầy đủ thông tin");
            setnutxuly(0);
            setnutorder("điền đủ thông tin");
            return;
        }
        axios
            .post("https://hust.media/api/v3", {
                action: 'add',
                key: apikey,
                link: 'https://hust.media',
                quantity: 1,
                service: service,
                national_market: national_market,
            })
            .then((response) => testFunction(response))
            .catch((error) => alert_error(error));
    }
    function testFunction(response) {
        const info = response.data;
        const orderok = info.order;
        const error = info.error;
        setnutorder("đặt tiếp luôn nào");
        setnutxuly(0);
        if (error) {
            alert_error(info.error);
        } else if (orderok) {
            alert_success('Thankiuu Bạn là người thứ ' + orderok + ' ủng hộ Hust Media');
        }
        else {
            alert_error('Lỗi không xác định vui lòng liên hệ admin');
        }
        if (info.redirect != null && info.redirect != "") {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        }
    }
    return (
        <>
            <div className='mt-4 mb-5 mx-2 '>
                <div className="border p-3 rounded-lg bg-white shadow-lg">
                    <button className="flex justify-between items-center mb-2 w-full">
                        <img src={item.img} alt="Mô tả ảnh" className="h-14 w-14 text-white" />
                        <p className="flex font-bold text-xl">
                            {item.name}
                            <FiEdit onClick={() => handleEditClick()} />
                        </p>
                    </button>

                    <button className="flex justify-between items-center mb-2 w-full">
                        <p className="fb-3 text-lg text-gray-700">{item.content}</p>
                        {item.category == 'link_ref' ? (
                            <>
                                <a href={item.api_url} target="_blank">
                                    <button className="rounded-full bg-blue-500 text-white px-4 py-2">Ấn đây để đăng ký</button>
                                </a>
                            </>
                        ) :
                            (<>
                                {item.category == 'promo_code' ? (
                                    <div className="flex items-center space-x-1">
                                        <div className="flex-grow bg-white border rounded-lg overflow-hidden shadow-md">
                                            <div className="flex flex-col p-1">
                                                <p className="text-base font-semibold text-gray-800 mb-1">Mã đăng ký</p>
                                                <div className="flex items-center space-x-0">
                                                    <button
                                                        onClick={() => saochep(item.api_key)}
                                                        className="bg-blue-500 text-white px-1 py-1 rounded-full hover:bg-blue-600 transition"
                                                    >
                                                        Sao chép
                                                    </button>
                                                    <div className="flex-grow bg-gray-100 border rounded-lg overflow-hidden p-1">
                                                        <p className="break-all text-gray-600">{item.api_key}</p>
                                                    </div>
                                                    {/* Thêm nút hoặc bất kỳ nội dung nào khác liên quan đến chức năng đăng ký */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : <></>}
                            </>)
                        }
                        <a href={item.contact} target="_blank">
                            <button className="rounded-full border-2 border-indigo-500 font-bold bg-green-500 text-white text-lg px-4 py-2">
                                Liên hệ hỗ trợ
                            </button>
                        </a>
                    </button>

                    <div className="border-t border-gray-300 my-2"></div>
                    <div className="grid grid-cols-3 gap-4 items-center">
                        <div className="mb-0 inline-block">
                            <span>🌾</span>
                            {
                                item.category != 'app_auto_jop' ?
                                    (<span className="text-lg font-semibold text-blue-600 block">{Math.round(+item.price / 100 * +item.received / 10) * 10} Coins</span>
                                    )
                                    :
                                    (<span className="text-lg font-semibold text-blue-600 block">+ {Math.round(+item.price / 100 * +item.received / 10) * 10} Coins/ngày</span>
                                    )
                            }
                        </div>
                        <div className="text-sm text-gray-600 mb-0 inline-block">
                            🌲 {item.limit}% hạn mức
                        </div>
                        <div className="text-sm text-gray-600 mb-0 inline-block">
                            {
                                item.category != 'app_auto_jop' ?
                                    (
                                        <div>🕑 {item.time} ngày</div>
                                    ) : (
                                        <>
                                            <a href="https://hust.media/jop/auto/download.php?app=uiviewcontroller" target="_blank" style={{ textDecoration: 'none' }} >
                                                <span className="text-lg font-semibold text-blue-600 block">Tải auto</span>
                                            </a>

                                        </>
                                    )
                            }
                        </div>
                    </div>
                </div>
                {/* Hướng dẫn đăng ký */}
                <div className="mt-4 p-3 border rounded-lg bg-white shadow-lg">
                    <p className="text-gray-700">
                        {item.category == 'app_auto_jop' ? (<>
                            <Select
                                classNamePrefix="Chọn 1 lựa chọn"
                                onFocus={handleFocus}
                                options={options.map((option) => ({
                                    value: option.id,
                                    label: `${option.name} ${option.money}`
                                }))}
                                menuIsOpen={isOpen}
                                onBlur={handleBlur}
                                onMenuOpen={handleMenuOpen}
                                onChange={handleOptionChange}
                                isDisabled={false}
                                isLoading={false}
                                isClearable={true}
                                isRtl={false}
                                isSearchable={false}
                            >

                            </Select>
                            {content && chietkhau &&
                                <div className="relative mt-0 p-2 mt-2 rounded-md border-2 border-pink-500 bg-white">
                                    <div className='text-sm'> rate gốc {content} Coins</div>
                                    <div className="text-xs lg:text-base">
                                        <span className="ml-1">&#10132;</span> Chiết khấu: {chietkhau}% 🎁
                                    </div>
                                    {money ? (
                                        <div className="text-lg lg:text-base">
                                            🌟 Tổng : {money} Coins
                                        </div>) : (<></>)}
                                </div>
                            }

                            <button disabled={nutxuly == 1} onClick={handleSubmit}
                                className='mt-2 mb-1 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2  w-full dark:bg-slate-800 dark:text-white'>
                                <div className='flex items-center justify-between flex-1'>
                                    {nutxuly == 1 &&
                                        <div className="spinner-border" role="status">

                                        </div>}


                                    <span className='text-lg font-medium text-white'>
                                        {nutorder} </span>
                                        <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                                </div>
                            </button>
                        </>) : (
                            <>
                                {showtele ? (
                                    <div className="text-center">
                                        Hướng dẫn
                                    </div>
                                ) :
                                    (<>
                                        <div className="text-center">
                                            Đang tải hướng dẫn
                                        </div>
                                        <div className="text-center">
                                            <ClipLoader size={80} color="#0000ff" />{" "}
                                        </div>
                                    </>)
                                }
                            </>
                        )}
                        <div id="telegram"></div>
                    </p>
                </div>
            </div>
        </>
    );
}

export default Getinfotask;
